export default {
    title: 'Macro-trends',
    subtitle: 'Macro-trends of the mega-trend'
}
